import { createApp, vaporInteropPlugin } from "vue";
import App from "@/App.vue";
import router from "@/router";
import pinia from "@/stores";
import { setupSentry } from "@/utils/sentry";
import "@/scss/main.scss";

const app = createApp(App);

// Vapor SFC(<script setup vapor>)와 일반 VDOM 컴포넌트 상호 운용
app.use(vaporInteropPlugin).use(router).use(pinia);

// 라우터 등록 이후에 초기화해야 라우트 기준 트랜잭션 이름이 잡힌다.
setupSentry(app, router);

app.mount("#app");
